import { useQuery } from "@apollo/client"
import { Chip } from "@heroui/react"
import { CircleStackIcon } from "@heroicons/react/24/outline"
import { ErrorPlaceholder, LoadingPlaceholder, SimplePlaceholder } from "@components"
import { GET_SUBJECT_LESSONS } from "@graphql"
import PropTypes from "prop-types"

const SubjectLessonsList = ({ subject }) => {
  const { loading, error, data } = useQuery(GET_SUBJECT_LESSONS, {
    fetchPolicy: "cache-first",
    variables: {
      id: subject.id,
    },
  })

  if (loading) return <LoadingPlaceholder caption="Loading lessons..." icon={CircleStackIcon} />

  if (error) return <ErrorPlaceholder caption="There was an error loading the lessons for this subject." error={error} />

  if (data.subject.lessons.length === 0) {
    return (
      <SimplePlaceholder isFullHeight={false} icon={CircleStackIcon} title="No lessons found for this subject">
        <p className="mt-1 text-sm text-gray-500">
          If you believe this subject should have associated lessons then please check your MIS and Xporter integration.
        </p>
      </SimplePlaceholder>
    )
  }

  return (
    <div>
      <Chip className="float-right" color="primary">
        {data.subject.lessons.length} lessons
      </Chip>

      <ul className="clear-right divide-y divide-gray-300 dark:divide-content2-foreground divide-dotted">
        {data.subject.lessons.map(lesson => (
          <li key={lesson.id} className="flex justify-between py-3">
            {lesson.name}
          </li>
        ))}
      </ul>
    </div>
  )
}

SubjectLessonsList.propTypes = {
  subject: PropTypes.object.isRequired,
}

export default SubjectLessonsList
